<div class="loading-container">
  <mat-spinner class="loading-spinner" [diameter]="30"></mat-spinner>
</div>
